// Invite tokens: a prospect (non-user) on someone's Top 8 can be invited to join,
// which upgrades the inviter's tile to a linked profile (claimInvite). Tokens are
// crypto-random and unguessable (a guessed token could be claimed by anyone).
import { db } from './firebase';
import { doc, setDoc } from 'firebase/firestore';

export function generateToken() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
  const a = new Uint8Array(16);
  crypto.getRandomValues(a);
  return Array.from(a, b => b.toString(16).padStart(2, '0')).join('');
}

export async function createInvite(entry, fromProfile) {
  const token = generateToken();
  const expires = new Date();
  expires.setDate(expires.getDate() + 30);
  await setDoc(doc(db, 'invites', token), {
    fromUid: fromProfile.uid,
    fromUsername: fromProfile.username,
    fromDisplayName: fromProfile.displayName,
    fromPhotoURL: fromProfile.photoURL || null,
    tileId: entry.id,
    tileName: entry.displayName,
    status: 'pending',
    createdAt: new Date(),
    expiresAt: expires,
    claimedBy: null,
  });
  return token;
}

export function inviteUrl(token) {
  return `${window.location.origin}/invite/${token}`;
}

export function inviteMessage(fromName, url) {
  return `Hey! ${fromName} just added you to their Top 8 on Your Top 8. Join to see your rank, get notified when it changes, and build your own! ${url}`;
}

// One-tap share: native share sheet when available, otherwise copy the link.
// Returns 'shared' | 'copied'.
export async function shareInvite(url, fromName) {
  const text = inviteMessage(fromName, url);
  if (navigator.share) {
    try { await navigator.share({ text, url }); return 'shared'; } catch { /* cancelled */ }
  }
  try { await navigator.clipboard.writeText(url); } catch { /* ignore */ }
  return 'copied';
}
